function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedal2Ok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1105.2 1105.2",
    style: {
      enableBackground: "new 0 0 1105.2 1105.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 1029.8353,
    cy: 532.9482,
    r: 35.9167,
    gradientTransform: "matrix(15.3856 0 0 15.3856 -15292.0342 -7647.1284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#202020"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6791,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M1105.2,552.6c0,305.2-247.4,552.6-552.6,552.6S0,857.8,0,552.6S247.4,0,552.6,0 S1105.2,247.4,1105.2,552.6z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000003073615947088702270000018079666075728889242_",
    cx: 1069.849,
    cy: 448.4949,
    r: 6.4866,
    gradientTransform: "matrix(-15.3856 0 0 -15.3856 17198.5684 7584.3633)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0620718,
    style: {
      stopColor: "#A4A4A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2124,
    style: {
      stopColor: "#737373"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3613,
    style: {
      stopColor: "#494949"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5058,
    style: {
      stopColor: "#292929"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6447,
    style: {
      stopColor: "#131313"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7756,
    style: {
      stopColor: "#050505"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8904,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003073615947088702270000018079666075728889242_)"
    },
    d: "M638.5,684c0-55.1,44.7-99.8,99.8-99.8 s99.8,44.7,99.8,99.8s-44.7,99.8-99.8,99.8C683.2,783.9,638.5,739.2,638.5,684z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176743331775621063980000013022178452158577335_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.2199,
    y1: -80.2043,
    x2: 902.9697,
    y2: 474.2916,
    gradientTransform: "matrix(1 0 0 1 -56.5508 272.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7212,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176743331775621063980000013022178452158577335_)"
    },
    d: "M1017.3,525 c0,256.6-208,464.6-464.7,464.6C296,989.6,88,781.6,88,525S296,60.4,552.6,60.4C809.3,60.3,1017.3,268.4,1017.3,525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124138185913275723640000000535632403958369409_",
    gradientUnits: "userSpaceOnUse",
    x1: 909.7426,
    y1: -90.4791,
    x2: 315.1957,
    y2: 587.7438,
    gradientTransform: "matrix(1 0 0 1 -56.5508 272.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7212,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124138185913275723640000000535632403958369409_)"
    },
    d: "M1008.5,525 c0,251.7-204.1,455.8-455.8,455.8C300.9,980.8,96.9,776.7,96.9,525S301,69.2,552.7,69.2C804.4,69.1,1008.5,273.2,1008.5,525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152236908424724604110000006896571172000909458_",
    gradientUnits: "userSpaceOnUse",
    x1: 169.2356,
    y1: -80.2061,
    x2: 902.9766,
    y2: 474.2829,
    gradientTransform: "matrix(1 0 0 1 -56.5508 272.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7212,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152236908424724604110000006896571172000909458_)"
    },
    d: "M968.9,525 c0,229.9-186.4,416.2-416.2,416.2S136.5,754.9,136.5,525c0-229.8,186.3-416.1,416.2-416.1C782.5,108.8,968.9,295.1,968.9,525z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000003826572170431246770000004669238760871373474_",
    cx: 1029.8385,
    cy: 531.1544,
    r: 26.0715,
    gradientTransform: "matrix(15.3856 0 0 15.3856 -15292.0342 -7647.1284)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2885,
    style: {
      stopColor: "#DFDFDF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3583,
    style: {
      stopColor: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4925,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6775,
    style: {
      stopColor: "#696969"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9042,
    style: {
      stopColor: "#121212"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9486,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9723,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "url(#SVGID_00000003826572170431246770000004669238760871373474_)",
      enableBackground: "new"
    },
    d: " M953.8,525c0,221.5-179.6,401.1-401.2,401.1c-221.5,0-401.1-179.6-401.1-401.1s179.6-401.1,401.1-401.1 C774.2,123.9,953.8,303.4,953.8,525z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169530557804170304130000017729376035475159457_",
    gradientUnits: "userSpaceOnUse",
    x1: 544.5499,
    y1: -106.3951,
    x2: 544.5499,
    y2: 634.9781,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#454545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2424,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    style: {
      stopColor: "#EEEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7212,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.794,
    style: {
      stopColor: "#868686"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8818,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9536,
    style: {
      stopColor: "#4D4D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#454545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000169530557804170304130000017729376035475159457_)",
      enableBackground: "new"
    },
    d: " M900.3,415c-2.2-7.5-4.9-14.5-7.3-21.2c-2.5-6.7-4.8-13.2-7.5-19.1c-5.5-11.9-10.5-22.5-15.5-31.5c-10.4-18-18.8-31.1-25.2-39.3 c-6.3-8.3-9.4-12.4-9.4-12.4s-1.8-2.5-5.2-6.5s-8.5-9.7-14.6-16.4c-3.1-3.3-6.4-7-10.1-10.6c-3.8-3.5-7.8-7.2-12-11.1 c-4.2-3.8-8.6-7.7-13.1-11.6c-4.7-3.7-9.5-7.4-14.4-11s-9.7-7.2-14.6-10.6c-5-3.2-10-6.3-14.8-9.2c-4.9-2.9-9.7-5.7-14.1-8.4 c-4.6-2.5-9-4.6-13.1-6.6c-8.2-4-15-7.2-19.9-9.4c-5-1.9-7.8-3-7.8-3s-8.2-3.2-20.7-7.6c-6.2-2.3-13.7-4.2-21.7-6.4 c-8-1.9-16.5-4.4-25.2-5.8c-8.7-1.5-17.4-2.8-25.5-4c-8.2-1.3-15.8-1.4-22.3-1.9c-13.1-0.7-21.9-0.9-21.9-0.9h-0.2 c0,0-10.8,0.2-26.9,1.2c-4,0.3-8.4,0.4-13,1c-4.6,0.7-9.4,1.4-14.5,2.1c-10.1,1.5-20.7,3.1-31.2,5.9c-5.3,1.4-10.5,2.8-15.7,4.1 c-5.2,1.4-10.2,2.8-15,4.6c-9.6,3.3-18.5,6.6-26.1,9.6c-7.5,3.1-13.6,6.1-17.8,8.1c-4.3,2.1-6.7,3.3-6.7,3.3s-5.6,2.7-11.1,5.6 c-5.3,3.2-10.7,6.3-10.7,6.3s-5.3,3.2-10.6,6.5c-2.6,1.7-5.2,3.3-7.2,4.6c-2,1.2-3.2,2.2-3.2,2.2s-5,3.6-10,7.3 c-4.9,3.7-9.9,7.4-9.9,7.4s-1.2,0.9-3.1,2.4c-1.9,1.4-4.3,3.3-6.6,5.4c-4.6,4.1-9.2,8.2-9.2,8.2s-4.6,4.2-9.1,8.4 c-4.6,4.1-8.8,8.7-8.8,8.7s-4.2,4.5-8.4,9.1c-4.1,4.6-8.2,9.2-8.2,9.2s-0.5,0.6-1.4,1.6s-2.2,2.5-3.6,4.3 c-2.9,3.7-6.6,8.6-10.3,13.6s-7.4,10-10,13.8c-2.5,3.9-4.2,6.6-4.2,6.6s-3.2,5.3-6.5,10.6c-3.1,5.4-6.3,10.7-6.3,10.7 s-0.8,1.3-1.9,3.4c-1.1,2.1-2.5,4.9-3.8,7.7c-2.7,5.6-5.4,11.2-5.4,11.2s-1.3,2.9-3.3,7c-2.1,4.2-4.4,10-6.5,15.8 c-4.4,11.6-8.4,23.4-8.4,23.4s-0.5,1.5-1.2,4.1c-0.7,2.7-1.8,6.4-3,10.9c-2.3,9.1-5.6,21.1-7.3,33.4c-1.9,12.3-4,24.6-4.2,33.8 c-0.5,9.2-0.9,15.4-0.9,15.4l-0.2,6.9l-0.2,6.8v0.2c0,0,0.2,9,0.9,22.6c0.3,13.6,3.1,31.7,6.2,49.7c1.8,9,4.2,17.8,6.3,26.1 c1.1,4.2,2.2,8.2,3.3,11.9c1.3,3.7,2.5,7.2,3.6,10.4c4.6,12.9,8,21.5,8,21.5s0.7,2.2,2.5,5.8c1.7,3.6,4.1,8.8,7.1,15 c5.7,12.6,15.1,28.2,24.9,43.6c5.2,7.5,10.6,14.8,15.8,21.6c5.1,6.9,10.3,12.9,14.9,17.9c9.1,10.1,15.4,16.7,15.4,16.7 s6.5,6.3,16.7,15.4c5,4.6,11,9.9,17.9,14.9c6.8,5.1,14.1,10.6,21.6,15.8c15.4,9.8,31,19.2,43.6,24.9c6.2,3.1,11.3,5.4,15,7.1 c3.6,1.8,5.8,2.5,5.8,2.5s8.6,3.4,21.5,8c3.2,1.1,6.7,2.3,10.5,3.6c3.8,1.1,7.8,2.1,11.9,3.3c8.3,2.1,17.2,4.5,26.2,6.3 c18,3.1,36.1,5.8,49.7,6.2c13.6,0.8,22.7,0.9,22.7,0.9h0.2c0,0,5.1-0.2,10.3-0.3c5.1-0.2,10.3-0.4,10.3-0.4s2.5-0.2,6.9-0.5 c4.4-0.2,10.8-0.6,18.3-1.7c7.6-1.1,16.4-2.4,25.8-4c9.4-1.8,19.3-4.5,29.2-7.1c9.9-2.4,19.5-6.1,28.6-9.4 c9-3.3,17.3-6.5,24.2-9.9c13.9-6.5,22.9-11.2,22.9-11.2s13.4-7.3,32.5-19.7c9.2-6.7,20-14.4,30.9-23.6 c10.6-9.5,22.1-19.4,32.1-30.8c5.1-5.6,10.2-11.2,15-16.9c4.6-5.9,9-11.7,13.3-17.4c8.7-11.2,15.4-22.8,21.3-32.6 c6-9.7,9.9-18.4,12.9-24.4c2.8-6,4.5-9.5,4.5-9.5s1.5-2.9,4-9c2.4-6.1,5.9-15.3,10.2-27.7c2.4-6.2,4-13.4,6.1-21.3 c1-4,2.1-8.2,3.2-12.6c1.1-4.4,2.1-9,2.8-13.8c1.6-9.7,3.3-20.2,4.6-31.6c0.8-11.3,1.5-23.6,1.8-36.5 C915.8,481.2,909.1,445,900.3,415z M546.6,523.4C546.6,523.5,546.5,523.4,546.6,523.4c-0.2-0.1-0.1,0.2-0.6,0.7 c0.2,0.4-0.4,0-0.2,0.4c-0.1,0.1-0.3-0.1-0.2,0.2c-0.4-0.3-0.2,0.2-0.2,0.2c-0.2-0.2-0.4,0.2-0.8,0c0-0.1-0.3,0.2-0.3,0.3 c0-0.3-0.5-0.3-0.7-0.1c-0.1-0.3-0.1-0.2-0.2-0.1c-0.1,0.2,0-0.2,0-0.2c-0.2,0.3,0-0.3-0.4,0c-0.1-0.4-0.4-0.6-0.5-0.4 c0.1-0.2,0-0.5-0.4-0.6c0.3-0.3-0.3-0.1,0-0.3c0,0-0.3,0.1-0.2,0s0.3-0.1,0-0.2c0.2-0.1,0.1-0.7-0.1-0.7l0.2-0.1l0.1-0.1 c-0.2-0.2,0.3-0.6-0.1-0.6c0.3,0.1,0-0.2,0.2-0.1c0,0,0.1,0,0-0.1s-0.1-0.1-0.1-0.1c0.2,0,0.3,0,0.2-0.1c0,0,0-0.1-0.1-0.1 c0.1,0,0.2,0,0.2,0v-0.2c0-0.1,0.1,0,0.1,0c0.1,0,0.2-0.1,0.2-0.2c-0.2-0.2,0.3,0,0.2-0.1c0,0,0-0.1,0-0.2c-0.1-0.2,0.2,0,0.1,0 c0.1,0.1,0.2-0.2,0.1-0.2c0-0.1,0.3,0.2,0.2,0c0,0,0,0,0-0.2c0.1,0.1,0.1,0.2,0.1,0.2s0.1,0,0.1-0.2c0.1,0.1,0.1,0.2,0.1,0 c-0.1-0.2,0,0,0,0c0,0.1,0.1,0.1,0.1,0.1c0.1,0,0.7-0.1,0.7-0.3c0,0,0.1,0.3,0.3,0.2c0.2-0.4,0.2,0.2,0.4-0.1 c0.1-0.2,0,0.3,0,0.1c0,0,0.2-0.3,0.1-0.1c0,0.2,0,0,0,0.1c0,0,0-0.1,0.1-0.2c0,0.2,0,0.3,0,0.2c0,0,0.1-0.1,0.1-0.2 c0,0.2,0,0.2,0,0.2s0.1,0,0.2-0.1v0.2c0,0,0.1,0,0.2-0.1c0,0.1,0,0.2,0,0.3c0,0,0.1,0,0.2,0c0.1,0,0,0.2,0,0.2 c0,0.1,0.2,0.1,0.3,0.1c0,0-0.1,0.2,0,0.1c-0.1,0.1,0.1,0.2,0.3,0.3c0,0.1-0.2,0.2,0,0.2c0.1,0-0.2,0.2-0.1,0.2 c-0.1,0,0.2-0.1,0.2,0c-0.2,0.1-0.2,0.1,0.2,0.8c0.1,0.8-0.5,0.6-0.2,0.8C546.4,523.2,546.5,523.3,546.6,523.4z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M905.1,606.8c8.8-25.2,14.4-52.3,16-81.1c7.4-110-50.7-222.5-139.1-288.7 c-87.8-67.7-205.7-89.3-303-50.8c-5,1.9-9.9,4-14.7,6.1c95.2-34.3,213.6-4.8,301.9,75.9C855.1,347.2,914,477.5,905.1,606.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070100897137130043350000004074444452025828225_",
    gradientUnits: "userSpaceOnUse",
    x1: 320.039,
    y1: 1.0236,
    x2: 588.6827,
    y2: 234.4351,
    gradientTransform: "matrix(1 0 0 1 -56.5508 272.6964)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5615,
    style: {
      stopColor: "#8B8B8B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F3F3F3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "url(#SVGID_00000070100897137130043350000004074444452025828225_)",
      enableBackground: "new"
    },
    d: " M831.7,246.5c-71.4-71.5-170-115.7-279-115.7C335,130.8,158.5,307.3,158.5,525c0,117.5,51.4,223,132.9,295.2 C429.9,540.1,668.1,351,831.7,246.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M408.7,764.7c7.9,17.6,5.2,36.4,2.2,37.5c-2.2,1-24.7-9.8-32.2-29.1c-7.6-19.1,1.2-36.5,4-37 C386.7,735.4,400.8,747.2,408.7,764.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130636762342141304650000011789546976386455462_",
    gradientUnits: "userSpaceOnUse",
    x1: 374.8153,
    y1: 507.1999,
    x2: 414.6613,
    y2: 507.1999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130636762342141304650000011789546976386455462_)"
    },
    d: "M410.4,803.1 c-4.3,0-25.3-11.2-32.6-29.7c-5.9-14.8-2-28.6,1.1-34.4c0.9-1.6,2.1-3.5,3.4-3.7c0.2,0,0.3,0,0.5,0c5.2,0,19,12.5,26.5,29.1 c6.9,15.4,5.7,31.3,3.5,36.4c-0.5,1.2-1.1,2-1.8,2.2C411,803,410.8,803.1,410.4,803.1z M383,736.8c-0.1,0-0.2,0-0.2,0 c-0.2,0.1-1.2,0.9-2.4,3.1c-3.7,6.9-6.1,19.6-0.9,32.8c7.2,18.3,27.9,28.7,31,28.7c0.1,0,0.1,0,0.1,0s0.4-0.2,0.9-1.3 c2.1-4.9,3.2-20.2-3.5-35.1C400,747.5,386.7,736.8,383,736.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M369.7,818.3c22.9,3.7,38.8-8.6,38.2-11.5c-0.6-2.3-19.3-16.6-40-20.9 c-20.8-4.3-38.8,2.9-39,6.2C328.6,796.7,346.7,814.6,369.7,818.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150101469472537290020000007248947251472989841_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.1872,
    y1: 539.9,
    x2: 408.851,
    y2: 539.9,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150101469472537290020000007248947251472989841_)"
    },
    d: "M378.3,819.9L378.3,819.9 c-2.9,0-5.8-0.2-8.7-0.7c-13.6-2.2-24.3-9.1-29.5-12.9c-7.2-5.4-12.2-11.3-11.9-14.1c0.2-3.6,12.8-8.3,26.7-8.3 c4.5,0,8.9,0.4,13.3,1.3c20.7,4.3,39.8,18.7,40.6,21.5c0.2,0.8-0.2,1.6-1,2.7C404.3,813.4,393.3,819.9,378.3,819.9z  M354.9,785.5c-14.9,0-24.9,5-25,6.8c-0.4,3.7,17,21.6,40,25.3c2.8,0.5,5.6,0.7,8.4,0.7l0,0c13.8,0,24.2-5.7,27.8-9.5 c0.9-1,1.1-1.5,1.1-1.6c-1.1-2.3-19.2-16.1-39.3-20.3C363.6,785.9,359.3,785.5,354.9,785.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M373.5,735c4.4,18.4-1.7,36.5-4.7,37.2c-2.2,0.7-21.8-13.3-25.7-33.4c-4-20,7.4-35.7,10.2-35.8 C357.4,702.9,369,716.6,373.5,735z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127005643506288107940000001227950465676140181_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.3994,
    y1: 475.65,
    x2: 375.8596,
    y2: 475.65,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127005643506288107940000001227950465676140181_)"
    },
    d: "M368.6,773 c-3.3,0-22.4-14.1-26.3-34.1c-3.1-15.6,3-28.5,7.1-33.7c1.1-1.4,2.6-3,3.9-3c5.1,0,16.7,15,21,32.7c3.8,16.1-0.2,31.5-3.2,36.3 c-0.7,1.1-1.4,1.7-2.1,1.9C368.8,773,368.7,773,368.6,773z M353.3,703.7c-0.3,0-1.3,0.7-2.8,2.7c-4.8,6.2-9.3,18.4-6.6,32.1 c3.8,19.5,22.4,32.8,24.7,32.8v0.8v-0.8c0,0,0.4-0.1,1.1-1.2c2.9-4.5,6.7-19.4,3-35C368.3,717,356.8,703.7,353.3,703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M326.5,781.8c21.3,7.1,38.7-2.7,38.7-5.5c-0.2-2.4-15.4-19.2-34.6-26.5 c-19.4-7.3-38.1-3.1-38.8,0.2C290.5,754.3,305,774.7,326.5,781.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116932208745880442520000017618984049702159254_",
    gradientUnits: "userSpaceOnUse",
    x1: 290.8172,
    y1: 502.9999,
    x2: 365.9843,
    y2: 502.9999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116932208745880442520000017618984049702159254_)"
    },
    d: "M341.9,785.2L341.9,785.2 c-5.3,0-10.6-0.9-15.7-2.6c-12.7-4.2-21.9-12.6-26.2-17.2c-6-6.4-9.8-13-9.1-15.7c0.6-2.7,8.3-4.9,17.6-4.9 c5.3,0,13.4,0.7,22.4,4.1c19.2,7.4,35,24.4,35.2,27.2C366,779.2,355.5,785.2,341.9,785.2z M308.5,746.5 c-9.8,0-15.7,2.4-15.9,3.6c-1,3.5,12.7,23.7,34.2,30.9c5,1.7,10.1,2.5,15.2,2.5c13.5,0,22.3-5.8,22.4-7.3 c-0.4-2.2-15.4-18.6-34.1-25.7C321.5,747.2,313.6,746.5,308.5,746.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M344.6,700.4c1.2,18.8-7.9,35.7-10.9,35.8c-2.3,0.3-18.8-16.4-19.3-36.8 c-0.6-20.2,13-34,15.8-33.7C334.2,666.4,343.4,681.7,344.6,700.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065759123198410225390000008361661746557613457_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.4814,
    y1: 439.05,
    x2: 345.5019,
    y2: 439.05,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065759123198410225390000008361661746557613457_)"
    },
    d: "M333.6,737.1 c-3.5,0-19.6-17.8-20.1-37.6c-0.4-13.8,5.7-25.2,11.6-31.2c1-1,3.4-3.3,5-3.3c0.1,0,0.1,0,0.2,0c5,0.8,14,17.3,15.1,35.4 c1,16.4-5.6,31-9.3,35.2c-0.9,1-1.6,1.5-2.4,1.5L333.6,737.1z M330.1,666.6c-0.4,0-1.8,0.8-3.8,2.8c-1.9,2-11.6,12.8-11.1,30 c0.5,19.6,16.2,35.6,18.4,36l0,0c0.1,0,0.5-0.2,1.2-1c3.6-4,9.9-18.1,8.9-33.9C342.6,681.9,333.5,667.2,330.1,666.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M291,739.4c19.5,10.2,38,3.2,38.5,0.4c0.3-2.4-11.6-21.2-29.2-31.3c-17.7-10.2-36.7-8.8-38-5.7 C260.4,706.8,271.3,729.1,291,739.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183948579645611871610000001152080705610390162_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.3206,
    y1: 460.5999,
    x2: 330.3054,
    y2: 460.5999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183948579645611871610000001152080705610390162_)"
    },
    d: "M312.5,745.6L312.5,745.6 c-7.5,0-15-1.9-21.9-5.5c-19.2-10-31.3-32.7-29-37.7c1-2.6,7.9-2.8,10-2.8c4.5,0,16.4,0.8,29.1,8.1 c17.5,10.2,29.9,29.3,29.6,32.2C329.8,742.5,321.7,745.6,312.5,745.6z M271.6,701.3c-5.8,0-8.3,1.2-8.5,1.7 c-1.5,3.3,8.5,25.3,28.3,35.6c6.6,3.5,13.9,5.3,21.1,5.3c9.7,0,15.9-3.2,16.2-4.3c0-2.2-11.7-20.6-28.8-30.5 C287.5,702.1,276,701.3,271.6,701.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M322.1,662.1c-1.9,18.7-13.5,33.9-16.5,33.6c-2.3,0-15.7-19-13-39.2c2.6-20,18.1-31.5,20.8-30.7 C317.2,627,323.9,643.5,322.1,662.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152265297624979687110000016385450780779838362_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.3529,
    y1: 398.6999,
    x2: 323.1932,
    y2: 398.6999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152265297624979687110000016385450780779838362_)"
    },
    d: "M305.7,696.5c-0.1,0-0.1,0-0.1,0 c-0.5,0-1.2-0.3-2.7-1.9c-4.6-5.2-13.4-21.5-11.2-38.2c2.6-20,17.6-31.5,21.3-31.5c0.2,0,0.4,0,0.5,0.1 c4.3,1.4,11.2,18,9.4,37.2C321,680.9,309.5,696.5,305.7,696.5z M313.1,626.5c-2.6,0-17.2,10.5-19.7,30 c-2.6,19.8,10.2,37.6,12.3,38.2l0,0c2.5,0,13.7-14.4,15.6-32.8C323,643.6,316.4,627.6,313.1,626.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M263.3,692.2c17.5,13.1,36.6,9,37.6,6.3c0.7-2.3-7.9-22.6-23.6-35.3 c-15.8-12.7-34.8-14.3-36.5-11.5C238.4,655.5,245.7,679.1,263.3,692.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072239755362040632010000004672275494964381883_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.5364,
    y1: 413.8499,
    x2: 301.738,
    y2: 413.8499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072239755362040632010000004672275494964381883_)"
    },
    d: "M289.8,702.1L289.8,702.1 c-5.5,0-16.2-1.2-27-9.3c-17.2-12.8-25.6-37.1-22.7-41.6c0.6-1.1,2.4-1.6,5.4-1.6c6.1,0,19.7,2.7,32.3,12.9 c15.6,12.7,24.6,33.4,23.9,36.2C301,700.7,295.9,702.1,289.8,702.1z M245.5,651.3c-2.9,0-3.8,0.6-4,0.8 c-2,3,4.5,26.2,22.2,39.4c10.4,7.8,20.8,8.9,26,8.9c6.4,0,10-1.6,10.3-2.2c0.4-2.2-8.1-22.1-23.3-34.4 C266.1,655.2,253.1,651.3,245.5,651.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M305.9,620.8c-4.7,18.1-18.5,31.3-21.4,30.6c-2.2-0.4-12.5-21.1-6.9-40.6 c5.5-19.4,22.5-28.3,25.1-27.1C306.3,585.4,310.5,602.7,305.9,620.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135690421752006032920000010846405588564377506_",
    gradientUnits: "userSpaceOnUse",
    x1: 275.1156,
    y1: 355.4,
    x2: 308.7432,
    y2: 355.4,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000135690421752006032920000010846405588564377506_)"
    },
    d: "M284.8,652.2c-0.2,0-0.3,0-0.4-0.1 c-0.5-0.1-1.1-0.4-2.3-2.3c-3.7-5.9-9.9-23.2-5.3-39.4c5.2-18.3,20.8-27.8,25.3-27.8c0.4,0,0.7,0.1,0.9,0.2 c4.1,2,8.5,19.5,3.7,38.2C302.1,638.7,288.8,652.2,284.8,652.2z M302.1,584.3c-3.2,0-18.5,8.6-23.7,26.6 c-5.5,19.1,4.4,38.7,6.3,39.6h0.1c3,0,15.9-12.8,20.3-30c4.6-17.9,0.4-34.7-2.8-36.2C302.3,584.4,302.2,584.3,302.1,584.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M243.4,641.5c15.3,15.6,34.7,14.5,36.1,12c1-2.1-4.3-23.5-17.9-38.5 c-13.7-15-32.2-19.5-34.4-16.9C224.3,601.4,228,625.8,243.4,641.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163035923694234711440000006088791076498420408_",
    gradientUnits: "userSpaceOnUse",
    x1: 225.4992,
    y1: 364.1499,
    x2: 280.356,
    y2: 364.1499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163035923694234711440000006088791076498420408_)"
    },
    d: "M273.2,655.8L273.2,655.8 c-4,0-18-1-30.4-13.7c-15-15.3-19.7-40.5-16.2-44.6c0.5-0.6,1.6-1,3.1-1c6.5,0,21.3,5.7,32.5,17.9c13.5,14.9,19.2,36.8,18,39.4 C279.2,655.6,274.6,655.8,273.2,655.8z M229.7,598.2c-1.2,0-1.7,0.2-1.9,0.4c-2.4,2.7,0.6,26.5,16.1,42.3 c12,12.3,25.4,13.2,29.2,13.2l0,0c3.6,0,5.3-0.7,5.5-1c0.7-2.1-4.6-23-17.8-37.5C250.1,603.7,235.9,598.2,229.7,598.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M296,577.6c-7.3,17.2-22.9,28.1-25.6,26.9c-2.1-0.7-9.2-22.8-0.9-41.2 c8.2-18.3,26.3-24.5,28.7-22.9C301.6,542.7,303.2,560.4,296,577.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169521397252500541420000017798466591589258649_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.7434,
    y1: 310.4,
    x2: 301.9227,
    y2: 310.4,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169521397252500541420000017798466591589258649_)"
    },
    d: "M270.9,605.4c-0.3,0-0.6-0.1-0.8-0.1 c-0.4-0.2-1-0.6-1.9-2.6c-2.8-6.4-6.4-24.4,0.6-39.7c7.5-16.6,23.3-23.6,28.3-23.6c0.7,0,1.2,0.1,1.6,0.4 c3.8,2.6,5.6,20.6-1.8,38.3C289.8,594.4,275,605.4,270.9,605.4z M297.1,541c-4.7,0-19.6,6.7-26.8,22.7 c-8.2,18-1.3,38.9,0.5,40.1c0,0,0.1,0,0.2,0c3.4,0,17.6-10.4,24.3-26.4c7.1-17,5.4-34.2,2.5-36.2l0,0 C297.7,541,297.5,541,297.1,541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M231.2,588.3c12.8,17.7,32.1,19.7,33.9,17.4c1.3-2-0.7-23.8-12-40.7 c-11.4-17-29.1-24.3-31.5-22.1C218.1,545.8,218.3,570.5,231.2,588.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072239259135520123840000000977419993713914813_",
    gradientUnits: "userSpaceOnUse",
    x1: 218.847,
    y1: 312.4999,
    x2: 266.228,
    y2: 312.4999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072239259135520123840000000977419993713914813_)"
    },
    d: "M261.9,607.3L261.9,607.3 c-6.2,0-20.8-3.9-31.4-18.5c-12.6-17.4-13.7-43.1-9.6-46.5c0.4-0.4,1.1-0.6,2-0.6c5.4,0,20.7,7.8,30.8,22.8 c11.2,16.8,13.6,39.3,12,41.7C265.2,607,263.9,607.3,261.9,607.3z M223,543.4c-0.7,0-0.9,0.2-0.9,0.2 c-2.7,2.3-3.2,26.3,9.8,44.3c9.4,13.1,23.1,17.8,30,17.8c1.7,0,2.4-0.3,2.5-0.4c1-1.9-1.2-23.5-12.1-39.8 C242.6,551,228,543.4,223,543.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M292.5,533.4c-9.6,15.9-26.7,24.2-29.2,22.6c-2-1-5.9-23.9,5-40.9 c10.8-16.8,29.5-20.1,31.6-18.2C302.9,499.7,302.1,517.5,292.5,533.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053503957663821351000000000148184499348299917_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.1404,
    y1: 264.3,
    x2: 302.3189,
    y2: 264.3,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000053503957663821351000000000148184499348299917_)"
    },
    d: "M264.2,557c-0.5,0-1-0.1-1.3-0.3 c-0.4-0.2-0.9-0.8-1.5-2.9c-1.5-5.4-3.5-24,6.2-39.1c9.2-14.4,24.3-19.1,30.1-19.1c1.3,0,2.3,0.2,2.8,0.7 c3.4,3.2,2.6,21.2-7.3,37.5C284.6,548,269.4,557,264.2,557z M297.7,497.2c-5.5,0-19.8,4.5-28.7,18.3 c-10.7,16.6-6.8,38.2-5.3,39.7c0,0,0.1,0.1,0.5,0.1c4.3,0,19.1-8.5,27.6-22.4c9.5-15.7,10.2-33,7.6-35.5 C299.3,497.4,298.8,497.2,297.7,497.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M226.9,533.9c10.1,19.5,28.9,24.4,31,22.5c1.6-1.7,2.7-23.7-6.1-42.1 c-8.9-18.5-25.3-28.5-28-26.7C220,489.8,216.7,514.4,226.9,533.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100346680150240801920000002790916443889119132_",
    gradientUnits: "userSpaceOnUse",
    x1: 219.3247,
    y1: 260.0499,
    x2: 259.8325,
    y2: 260.0499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000100346680150240801920000002790916443889119132_)"
    },
    d: "M256.3,557.6L256.3,557.6 c-6.3,0-21.6-6.8-30.1-23.3c-10-19.2-7.4-44.7-2.8-47.5c0.3-0.2,0.8-0.3,1.3-0.3c5.1,0,19.9,10.7,27.9,27.4 c8.7,18.4,7.9,40.9,6,43C258,557.4,257.3,557.6,256.3,557.6z M224.7,488.2c-0.3,0-0.4,0.1-0.4,0.1c-3,1.8-6.9,25.5,3.4,45.3 c8.9,17.1,24.1,22.4,28.6,22.4l0,0c0.7,0,1-0.1,1.1-0.2c1-1.4,2.7-22.3-6.3-41.2C243.2,498.2,228.8,488.2,224.7,488.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M295.3,489.1c-11.8,14.2-29.8,19.8-32.1,17.8c-1.8-1.3-2.4-24.6,10.8-39.6 c13.1-15,32.1-15.4,33.9-13.1C310.5,457.4,307,474.9,295.3,489.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078024302063892690090000009644990465638392204_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.4504,
    y1: 218.1499,
    x2: 309.5044,
    y2: 218.1499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078024302063892690090000009644990465638392204_)"
    },
    d: "M264.9,508.1c-1,0-1.7-0.2-2.2-0.6 c-0.4-0.3-0.8-0.9-1.1-3.3c-0.6-5.5,0.1-24.3,11.8-37.6c9.3-10.6,21.9-14.4,29.9-14.4c1.6,0,4.3,0.2,5.3,1.3 c2.9,3.7-0.5,21.4-12.6,36C285.7,502,270.5,508.1,264.9,508.1z M303.3,454c-7.6,0-19.7,3.6-28.7,13.8 c-12.7,14.5-12.2,36.8-10.9,38.5c0,0,0.2,0.2,1.1,0.2c4.4,0,19.2-5.2,29.8-17.9c11.6-14,14.8-31.1,12.6-33.9 C307.1,454.4,305.9,454,303.3,454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M230.4,479.5c7.2,20.9,25.1,28.6,27.5,27c1.8-1.5,6-23,0-42.6c-6.1-19.7-20.9-32.1-23.9-30.8 C229.9,434.8,223,458.5,230.4,479.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082333846285967179830000004355182425769761200_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.3463,
    y1: 207.7999,
    x2: 261.7511,
    y2: 207.7999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082333846285967179830000004355182425769761200_)"
    },
    d: "M256.9,507.5L256.9,507.5 c-4.9,0-20.7-8.5-27.3-27.8c-7.2-20.6-0.9-45.4,4-47.4c0.2-0.1,0.5-0.2,0.9-0.2c4.3,0,18.2,12.2,24.1,31.5 c6,19.5,2,41.7-0.3,43.5C258,507.4,257.5,507.5,256.9,507.5z M234.5,433.9c-0.1,0-0.2,0-0.2,0c-3.3,1.3-10.5,24.1-3.1,45.3 c6.5,18.6,21.8,26.6,25.8,26.6l0,0c0.3,0,0.4-0.1,0.4-0.1c1.6-1.6,5.6-22.5-0.3-41.7C251.3,445.8,237.8,433.9,234.5,433.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M304.5,445.7c-13.7,12.2-32.3,15-34.3,12.7c-1.6-1.6,1.2-24.7,16.4-37.6 c15.1-12.8,34-10.2,35.5-7.8C324.1,416.7,318.1,433.5,304.5,445.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157992697451677330520000009918564195755268758_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.9276,
    y1: 173.0999,
    x2: 323.3192,
    y2: 173.0999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157992697451677330520000009918564195755268758_)"
    },
    d: "M273.4,460c-2,0-3.2-0.3-3.8-1 c-0.2-0.2-0.7-0.8-0.6-3.5c0.3-8.3,5.2-25.2,17.1-35.3c10.7-9,22.5-10,27.1-10c4.1,0,8.7,0.7,9.7,2.4 c2.3,4.1-3.7,21.1-17.8,33.7C293.9,456.3,279.7,460,273.4,460z M313.1,411.9c-4.4,0-15.8,0.9-26,9.6 c-14.7,12.4-17.4,34.6-16.3,36.4c0.1,0.1,0.8,0.5,2.6,0.5c6.1,0,19.7-3.6,30.5-13.2c13.5-12.1,19.2-28.5,17.5-31.6 C321.1,413,318.3,411.9,313.1,411.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M241.6,426.2c4.1,21.8,20.7,32.2,23.3,31c2-1.2,9.3-21.8,6.2-42.2 c-3.2-20.5-15.9-35.1-19.1-34.2C247.7,381.8,237.4,404.3,241.6,426.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043434058082588078020000003860988252511815845_",
    gradientUnits: "userSpaceOnUse",
    x1: 239.8299,
    y1: 157,
    x2: 272.6545,
    y2: 157,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000043434058082588078020000003860988252511815845_)"
    },
    d: "M264.4,458.1L264.4,458.1 c-4.5,0-19.6-10.9-23.6-31.8c-4.1-21.5,5.8-45.1,11-46.3c0.1,0,0.3-0.1,0.5-0.1c4.2,0,16.5,14.7,19.6,34.9 c3.1,20.3-4.2,41.6-6.6,43C265,458,264.7,458.1,264.4,458.1z M252.3,381.6h-0.1c-3.4,0.8-14,22.3-9.7,44.4 c3.8,20.3,18.8,30.4,21.9,30.4l0,0c0.1,0,0.1,0,0.1,0c1.9-1.6,8.7-21.5,5.7-41.3C267.2,395.5,255.4,381.6,252.3,381.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M320,404.2c-15.4,10-34.3,9.8-35.9,7.2c-1.4-1.8,4.8-24.3,21.9-34.7c17-10.3,35.4-4.9,36.4-2.2 C343.9,378.5,335.3,394.2,320,404.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148646841188158514230000018062187804770342069_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.0585,
    y1: 129.8499,
    x2: 343.4897,
    y2: 129.8499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148646841188158514230000018062187804770342069_)"
    },
    d: "M291,413.8c-2.4,0-6.6-0.2-7.6-1.9 c-0.2-0.3-0.6-0.9-0.1-3.6c1.5-8.2,9-24.1,22.3-32.2c8.4-5.1,16.7-6.2,22.2-6.2c8.1,0,14.7,2.3,15.5,4.4 c1.6,4.4-7,20.3-22.9,30.6C310.3,411.4,298.6,413.8,291,413.8z M327.8,371.5c-5.3,0-13.3,1-21.3,5.9 C290,387.5,284,409,284.8,411c0.2,0.4,2,1.1,6.2,1.1c7.3,0,18.7-2.3,28.5-8.6c15.2-9.9,23.4-25.2,22.2-28.6 C341.4,374,336,371.5,327.8,371.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M260.6,375.1c0.8,22.2,15.7,35.1,18.4,34.3c2.2-0.9,12.4-20.2,12.5-40.8 c0-20.8-10.3-37.2-13.6-36.8C273.5,332.1,259.8,352.8,260.6,375.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036930146937427975340000005445820672143966637_",
    gradientUnits: "userSpaceOnUse",
    x1: 259.7728,
    y1: 108.5499,
    x2: 292.3707,
    y2: 108.5499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036930146937427975340000005445820672143966637_)"
    },
    d: "M278.8,410.2L278.8,410.2 c-3.7,0-18.2-13.2-18.9-35.1c-0.8-21.9,12.7-43.8,18.1-44.2c0,0,0.1,0,0.2,0c0.8,0,1.8,0.5,2.8,1.6c4.8,4.8,11.5,19.1,11.5,36 c-0.1,21-10.4,40.5-13,41.6C279.1,410.2,278.9,410.2,278.8,410.2z M278.1,332.6c-3.6,0.3-17.5,19.9-16.6,42.5 c0.8,21.4,14.8,33.5,17.3,33.5l0,0c2.1-1.3,11.8-20,11.9-40c0-16.2-6.5-30.4-11-34.8C278.6,332.6,278.1,332.6,278.1,332.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M341.8,365.4c-16.9,7.5-35.6,4.5-36.7,1.6c-1.1-2,8.6-23.3,27.3-30.9 c18.6-7.6,36.1,0.6,36.7,3.5C369.8,343.7,358.6,357.9,341.8,365.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079467552265313293370000011510789550351586693_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.1366,
    y1: 89.5999,
    x2: 370.0405,
    y2: 89.5999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079467552265313293370000011510789550351586693_)"
    },
    d: "M318.9,371c-6.5,0-13.6-1.2-14.6-3.5 c-0.1-0.3-0.5-1,0.5-3.6c2.8-7.9,12.7-22.5,27.3-28.5c5.2-2.1,10.7-3.2,16.4-3.2c11.7,0,20.9,4.7,21.5,7.2 c0.8,4.6-10.3,19-27.8,26.8C335.2,369.3,326.9,371,318.9,371z M348.4,333.8c-5.4,0-10.7,1-15.7,3.1 c-18,7.3-27.4,27.8-26.9,29.8c0.3,0.7,4.7,2.6,13.1,2.6c7.8,0,15.8-1.6,22.5-4.6c16.8-7.5,27.5-21.4,26.8-24.9 C368,338.5,360.2,333.8,348.4,333.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M287.5,327.5c-2.7,22.1,10.1,37.2,12.8,36.8c2.3-0.5,15.4-18.1,18.9-38.5 c3.4-20.6-4.1-38.4-7.4-38.5C307.3,286.9,290.2,305.2,287.5,327.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019661573992076872170000010337024331587469493_",
    gradientUnits: "userSpaceOnUse",
    x1: 286.2269,
    y1: 63.7499,
    x2: 320.9857,
    y2: 63.7499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000019661573992076872170000010337024331587469493_)"
    },
    d: "M300.2,365.1L300.2,365.1 c-1.4,0-3.3-1.9-4.3-3c-5.5-6.2-11.2-19.1-9.3-34.7c2.6-21.5,19.4-41,25.1-41c0.1,0,0.1,0,0.2,0c0.7,0,1.5,0.5,2.4,1.6 c3.5,4.3,8.8,19.8,5.8,37.9c-3.6,20.8-16.8,38.5-19.6,39.2C300.4,365.1,300.3,365.1,300.2,365.1z M300.2,363.8v0.5V363.8 L300.2,363.8z M311.7,288.1c-3.8,0-20.7,17.3-23.4,39.5c-1.9,15.1,3.6,27.5,8.9,33.4c1.7,1.9,2.7,2.4,3,2.4 c2.3-1,14.9-17.9,18.3-37.8c2.9-17.6-2.1-32.5-5.5-36.6C312.4,288.3,312,288.1,311.7,288.1L311.7,288.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M369.9,330.5c-18.2,4.8-36.2-1.1-37-4.1c-0.8-2.2,12.4-21.8,32.6-26.4c20-4.7,36.2,6.2,36.3,9.1 C401.9,313.2,388,325.6,369.9,330.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118369119190694980410000017244333786523423924_",
    gradientUnits: "userSpaceOnUse",
    x1: 332.1445,
    y1: 53.5499,
    x2: 402.8,
    y2: 53.5499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000118369119190694980410000017244333786523423924_)"
    },
    d: "M355.5,333.1c-12,0-22.5-3.5-23.3-6.5 c-0.1-0.4-0.2-1.3,1-3.3c2.7-5,14.4-20,32.3-24.1c3.3-0.8,6.7-1.2,10.1-1.2c15.2,0,27.1,7.8,27.2,11.1 c0,5.1-15.2,17.6-32.6,22.2C365.5,332.5,360.5,333.1,355.5,333.1z M375.5,299.7c-3.3,0-6.6,0.4-9.8,1.1 c-19.8,4.6-32.2,23.2-32,25.4c0.3,1.3,8.8,5.3,21.7,5.3c4.9,0,9.7-0.6,14.2-1.8c18.1-4.9,31.4-16.9,31.4-20.6 C401,307.3,390.5,299.7,375.5,299.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M397.5,282.6c-17.2,12.1-37.5,15.2-39.6,13.2c-1.6-1.4,2.8-23.5,22.1-37.2 c19.3-13.7,42.7-12,43.9-9.4C425.6,252.9,414.6,270.4,397.5,282.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026856254825723228450000013696694039894210192_",
    gradientUnits: "userSpaceOnUse",
    x1: 356.7112,
    y1: 9.85,
    x2: 424.8564,
    y2: 9.85,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026856254825723228450000013696694039894210192_)"
    },
    d: "M360.6,297.2c-2.3,0-3-0.4-3.4-0.8 c-0.5-0.4-0.6-1.2-0.6-2.5c0.3-6.7,6.3-24.3,22.8-36c14.8-10.5,30.9-11.4,35.4-11.4c2,0,8.8,0.2,9.7,2.3 c2.1,4.3-9.5,22.1-26.6,34.4C384.3,292.9,367.9,297.2,360.6,297.2z M358.5,295.2c0.2,0.1,0.7,0.3,2.2,0.3 c7.1,0,23-4.2,36.4-13.6c17.3-12.3,27.5-29.4,26.1-32.3c-0.3-0.5-3.1-1.3-8.2-1.3c-4.4,0-20,0.8-34.5,11.1 C362.3,272.2,357.5,292.9,358.5,295.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M322.1,284.4c-6.5,21.5,3.8,38.4,6.6,38.4c2.3-0.2,18.4-15.5,25.5-35.2 c7.1-19.8,2.8-38.7-0.6-39.3C349.1,247.3,328.5,262.8,322.1,284.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064320573111117985350000010984169075309147275_",
    gradientUnits: "userSpaceOnUse",
    x1: 319.1314,
    y1: 23.6,
    x2: 358.8879,
    y2: 23.6,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000064320573111117985350000010984169075309147275_)"
    },
    d: "M328.7,323.7L328.7,323.7 c-1,0-2.1-0.9-3.3-2.6c-3.8-5.1-9.5-19.4-4.2-36.9c6.2-20.8,25.8-36.7,31.9-36.7c0.2,0,0.5,0,0.7,0.1c0.7,0.1,1.5,0.8,2.1,1.9 c2.8,4.8,5.3,21-0.9,38.5C347.8,308,331.6,323.5,328.7,323.7L328.7,323.7z M353.2,249.2c-4.7,0-24.1,14.7-30.3,35.5 c-4.8,16-0.1,29.4,3.4,34.8c1.3,1.9,2.1,2.5,2.4,2.6c2.4-0.6,17.8-15.4,24.7-34.6c6.1-17,3.7-32.5,1-37.1c-0.6-1-1-1.1-1-1.1 C353.4,249.2,353.3,249.2,353.2,249.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M411.3,802.8c-0.4-0.2-1.2,0.5-1.9,1.6c-0.7,1.1-0.9,2.2-0.5,2.4c37.7,22.1,82.5,37.3,134.3,43 c0.2-1.5,0.3-3,0.5-4.6C492.5,839.5,448.4,824.6,411.3,802.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142891617513807558790000011272308603889382793_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.7646,
    y1: 564.3,
    x2: 544.4999,
    y2: 564.3,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000142891617513807558790000011272308603889382793_)"
    },
    d: "M543.8,850.7l-0.8-0.1 c-49.9-5.5-95.2-20-134.6-43.1c-0.2-0.1-0.5-0.3-0.6-0.8c-0.2-1,0.5-2.4,0.8-2.8c0.3-0.5,1.3-2,2.5-2c0.2,0,0.4,0.1,0.6,0.2 c38.7,22.6,83.1,36.9,132,42.3l0.8,0.1L543.8,850.7z M409.5,806.2c39,22.8,83.7,37.1,132.9,42.7l0.3-2.9 c-48.8-5.5-93.1-19.7-131.7-42.3c-0.2,0.1-0.6,0.5-1,1.2C409.7,805.4,409.5,805.9,409.5,806.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M696.5,764.7c-7.9,17.6-5.2,36.4-2.2,37.5c2.2,1,24.7-9.8,32.2-29.1c7.6-19.1-1.1-36.5-4-37 C718.5,735.4,704.5,747.2,696.5,764.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077316463296584901740000001724874652358569109_",
    gradientUnits: "userSpaceOnUse",
    x1: 690.5616,
    y1: 507.1499,
    x2: 730.4101,
    y2: 507.1499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000077316463296584901740000001724874652358569109_)"
    },
    d: "M694.8,803.1L694.8,803.1 c-0.3,0-0.5,0-0.8-0.2c-0.6-0.2-1.2-1-1.8-2.2c-2.2-5.1-3.4-21,3.5-36.4c7.5-16.6,21.2-29.1,26.5-29.1c0.2,0,0.3,0,0.5,0 c1.3,0.3,2.6,2.2,3.5,3.7c3.2,5.8,7,19.6,1.1,34.4C720.1,791.9,699.1,803.1,694.8,803.1z M722.3,736.8c-3.7,0-17,10.6-25,28.2 c-6.7,14.9-5.6,30.2-3.5,35.1c0.5,1.2,0.9,1.3,0.9,1.3h0.1c3.1,0,23.9-10.3,31-28.7c5.2-13.1,2.7-25.9-0.9-32.8 c-1.2-2.2-2.1-3-2.4-3.1C722.4,736.9,722.4,736.8,722.3,736.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M735.5,818.3c-22.9,3.7-38.8-8.6-38.2-11.5c0.6-2.3,19.3-16.6,40-20.9c20.8-4.3,38.8,2.9,39,6.2 C776.6,796.7,758.5,814.6,735.5,818.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176028365037566156220000015559106848850686652_",
    gradientUnits: "userSpaceOnUse",
    x1: 696.3849,
    y1: 539.85,
    x2: 777.0128,
    y2: 539.85,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176028365037566156220000015559106848850686652_)"
    },
    d: "M727,819.9 c-15.1,0-26.1-6.5-29.5-10.6c-0.8-1-1.2-1.9-1.1-2.6c0.8-2.9,19.9-17.2,40.6-21.6c4.3-0.9,8.8-1.3,13.3-1.3 c13.9,0,26.5,4.7,26.7,8.3c0.3,2.8-4.7,8.7-11.9,14.1c-5.2,3.9-15.9,10.8-29.5,12.9C732.7,819.6,729.8,819.9,727,819.9z  M698.1,807c0,0.1,0.1,0.6,1.1,1.6c3.6,3.8,14,9.5,27.8,9.5c2.8,0,5.6-0.2,8.4-0.7c23-3.7,40.4-21.6,40-25.2 c-0.1-1.8-10.1-6.8-25-6.8c-4.4,0-8.7,0.4-13,1.3C717.3,791,699.1,804.7,698.1,807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M731.8,735c-4.4,18.4,1.7,36.5,4.7,37.2c2.2,0.7,21.8-13.3,25.7-33.4c4-20-7.4-35.7-10.2-35.8 C747.8,702.9,736.2,716.6,731.8,735z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079473527579845264920000004667960136494178976_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.3642,
    y1: 475.5499,
    x2: 763.8244,
    y2: 475.5499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079473527579845264920000004667960136494178976_)"
    },
    d: "M736.7,773L736.7,773 c-0.1,0-0.3,0-0.4,0c-0.7-0.2-1.4-0.8-2.1-1.9c-3-4.7-7-20.2-3.2-36.3c4.3-17.7,15.9-32.7,21-32.7c1.3,0,2.9,1.7,3.9,3 c4.1,5.2,10.2,18.2,7.1,33.7C759.1,758.8,739.9,773,736.7,773z M751.9,703.7c-3.5,0-14.9,13.3-19.3,31.4 c-3.7,15.6,0.1,30.5,3,35c0.7,1.1,1.1,1.2,1.1,1.2l0,0c2.3-0.1,20.9-13.3,24.7-32.8c2.7-13.8-1.9-25.9-6.6-32.1 C753.2,704.4,752.2,703.7,751.9,703.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M778.8,781.8c-21.3,7.1-38.7-2.7-38.7-5.5c0.2-2.4,15.4-19.2,34.6-26.5 c19.4-7.3,38.1-3.1,38.8,0.2C814.7,754.3,800.2,774.7,778.8,781.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171717789624178350030000010372791313819749300_",
    gradientUnits: "userSpaceOnUse",
    x1: 739.2,
    y1: 503.05,
    x2: 814.3765,
    y2: 503.05,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171717789624178350030000010372791313819749300_)"
    },
    d: "M763.3,785.2 c-13.6,0-24.1-5.9-24.1-8.9c0.2-2.9,15.9-19.9,35.2-27.3c8.9-3.4,17.1-4.1,22.4-4.1c9.2,0,16.9,2.2,17.6,4.9 c1.4,5.3-14.4,25.9-35.3,32.8C773.9,784.3,768.6,785.2,763.3,785.2z M796.7,746.5c-5.1,0-13.1,0.7-21.8,4 c-18.7,7.2-33.7,23.6-34.1,25.8c0.2,1.4,8.9,7.2,22.4,7.2c5.1,0,10.2-0.8,15.2-2.5c21.5-7.1,35.2-27.3,34.2-30.8 C812.4,748.9,806.5,746.5,796.7,746.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M760.6,700.4c-1.2,18.8,7.9,35.7,10.9,35.8c2.3,0.3,18.8-16.4,19.3-36.8 c0.6-20.2-13.1-34-15.8-33.7C771,666.4,761.8,681.7,760.6,700.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031201277287763995760000010534920051053581461_",
    gradientUnits: "userSpaceOnUse",
    x1: 759.6967,
    y1: 439.0499,
    x2: 791.7445,
    y2: 439.0499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031201277287763995760000010534920051053581461_)"
    },
    d: "M771.6,737.1L771.6,737.1L771.6,737.1 c-0.8,0-1.6-0.5-2.5-1.5c-3.8-4.2-10.3-18.8-9.3-35.2c1.2-18.1,10.1-34.6,15.1-35.4c0.1,0,0.2,0,0.2,0c1.6,0,4.1,2.3,5,3.3 c5.8,6,11.9,17.4,11.6,31.2C791.2,719.3,775.1,737.1,771.6,737.1z M775.1,666.6c-3.4,0.5-12.5,15.3-13.7,33.9 c-1,15.9,5.3,29.9,8.9,33.9c0.7,0.8,1.1,1,1.2,1l0,0c2.2-0.4,17.9-16.4,18.4-36c0.5-17.2-9.1-28-11.1-30 C777,667.4,775.5,666.6,775.1,666.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M814.3,739.4c-19.5,10.2-38,3.2-38.5,0.4c-0.3-2.4,11.6-21.2,29.2-31.3 c17.7-10.2,36.7-8.8,38-5.7C844.8,706.8,833.9,729.1,814.3,739.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047056290563730354370000011320426682042602431_",
    gradientUnits: "userSpaceOnUse",
    x1: 774.9946,
    y1: 460.6499,
    x2: 844.0571,
    y2: 460.6499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047056290563730354370000011320426682042602431_)"
    },
    d: "M792.8,745.6 c-9.3,0-17.3-3.1-17.8-5.6c-0.3-2.9,12-22.1,29.6-32.2c12.7-7.3,24.6-8.1,29.1-8.1c2.1,0,9,0.2,10.1,2.8 c2.2,4.9-9.9,27.7-29.1,37.7C807.8,743.7,800.2,745.6,792.8,745.6z M833.6,701.3c-4.4,0-15.9,0.8-28.3,7.9 c-17,9.9-28.8,28.3-28.7,30.5c0.3,1,6.5,4.2,16.2,4.2c7.2,0,14.5-1.8,21.1-5.3c19.8-10.3,29.8-32.2,28.3-35.5 C841.9,702.5,839.5,701.3,833.6,701.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M783.1,662.1c1.9,18.7,13.5,33.9,16.5,33.6c2.3,0,15.7-19,13.1-39.2 c-2.6-20-18.1-31.5-20.8-30.7C788,627,781.3,643.5,783.1,662.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057838908789082395410000007287638818175636922_",
    gradientUnits: "userSpaceOnUse",
    x1: 781.9762,
    y1: 398.7,
    x2: 813.846,
    y2: 398.7,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057838908789082395410000007287638818175636922_)"
    },
    d: "M799.5,696.5L799.5,696.5 c-3.8,0-15.4-15.6-17.2-34.3c-1.9-19.2,5-35.9,9.3-37.2c0.2,0,0.4-0.1,0.5-0.1c3.7,0,18.7,11.5,21.3,31.5 c2.2,16.7-6.6,32.9-11.2,38.2C800.7,696.3,800,696.5,799.5,696.5C799.6,696.5,799.6,696.5,799.5,696.5z M792.2,626.5 c-3.4,1-10,17-8.2,35.5s13.1,32.8,15.6,32.8h0.1c2-0.6,14.8-18.5,12.2-38.2C809.3,637,794.8,626.5,792.2,626.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M842,692.2c-17.5,13.1-36.6,9-37.6,6.3c-0.7-2.3,7.9-22.6,23.6-35.3 c15.8-12.7,34.8-14.3,36.5-11.5C866.9,655.5,859.6,679.1,842,692.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055691332811687278160000018020323876447022234_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.4508,
    y1: 413.8499,
    x2: 865.6614,
    y2: 413.8499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055691332811687278160000018020323876447022234_)"
    },
    d: "M815.4,702.1 c-6.1,0-11.2-1.4-11.9-3.3c-0.8-2.8,8.2-23.6,23.8-36.3c12.6-10.2,26.3-12.9,32.3-12.9c3,0,4.8,0.5,5.4,1.6 c2.9,4.5-5.5,28.8-22.7,41.6C831.7,700.9,820.9,702.1,815.4,702.1z M859.7,651.3c-7.6,0-20.6,3.9-31.3,12.5 c-15.2,12.3-23.7,32.2-23.3,34.5c0.3,0.5,3.8,2.2,10.3,2.2c5.3,0,15.6-1.2,26-8.9c17.8-13.2,24.2-36.4,22.3-39.4 C863.6,651.9,862.6,651.3,859.7,651.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M799.3,620.8c4.7,18.1,18.5,31.3,21.4,30.6c2.2-0.4,12.5-21.1,6.9-40.6 c-5.5-19.4-22.5-28.3-25.1-27.1C798.9,585.4,794.7,602.7,799.3,620.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147211424196119897820000009809639386879029135_",
    gradientUnits: "userSpaceOnUse",
    x1: 796.4529,
    y1: 355.3999,
    x2: 830.1071,
    y2: 355.3999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147211424196119897820000009809639386879029135_)"
    },
    d: "M820.5,652.2L820.5,652.2 c-4,0-17.4-13.5-21.9-31.2c-4.8-18.7-0.4-36.2,3.7-38.2c0.3-0.1,0.6-0.2,1-0.2c4.5,0,20.1,9.6,25.3,27.8 c4.7,16.2-1.5,33.6-5.3,39.4c-1.2,1.8-1.8,2.2-2.3,2.3C820.8,652.2,820.6,652.2,820.5,652.2z M803.2,584.3c-0.2,0-0.2,0-0.2,0 c-3.2,1.6-7.3,18.3-2.8,36.2c4.4,17.2,17.4,30,20.3,30l0,0c0,0,0,0,0.1,0h0.1c1.9-0.9,11.7-20.5,6.2-39.6 C821.7,592.9,806.3,584.3,803.2,584.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M861.9,641.5c-15.3,15.6-34.7,14.5-36.1,12c-1-2.1,4.3-23.5,17.9-38.5 c13.7-15,32.2-19.5,34.4-16.9C881,601.4,877.2,625.8,861.9,641.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145767456604035939130000010242867467145913734_",
    gradientUnits: "userSpaceOnUse",
    x1: 824.8892,
    y1: 364.1999,
    x2: 879.7704,
    y2: 364.1999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145767456604035939130000010242867467145913734_)"
    },
    d: "M832,655.8c-1.4,0-6-0.1-7-1.9 c-1.3-2.7,4.4-24.5,18-39.4c11.2-12.2,26-17.9,32.5-17.9c1.5,0,2.6,0.3,3.1,1c3.5,4-1.2,29.2-16.2,44.5 C850,654.8,836,655.8,832,655.8z M875.5,598.2c-6.2,0-20.4,5.5-31.2,17.4c-13.1,14.5-18.5,35.4-17.7,37.5c0.2,0.3,1.9,1,5.5,1 c7.9,0,19.7-3.5,29.2-13.2c15.5-15.8,18.5-39.6,16.1-42.3C877.3,598.4,876.7,598.2,875.5,598.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M809.2,577.6c7.3,17.2,22.9,28.1,25.6,26.9c2.1-0.7,9.2-22.8,0.9-41.2 c-8.3-18.3-26.3-24.5-28.7-22.9C803.7,542.7,802,560.4,809.2,577.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057149326752422953580000013552526189241216919_",
    gradientUnits: "userSpaceOnUse",
    x1: 803.2874,
    y1: 310.3,
    x2: 840.4699,
    y2: 310.3,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057149326752422953580000013552526189241216919_)"
    },
    d: "M834.3,605.4L834.3,605.4 c-4.1,0-18.9-11-25.9-27.5c-7.4-17.7-5.6-35.6-1.9-38.3c0.4-0.3,0.9-0.4,1.6-0.4c5,0,20.8,7,28.3,23.6 c6.9,15.3,3.4,33.4,0.6,39.7c-0.9,2-1.5,2.4-1.9,2.6C834.9,605.3,834.6,605.4,834.3,605.4z M808.1,541c-0.5,0-0.7,0.1-0.7,0.1 c-2.9,2-4.6,19.3,2.5,36.2c6.8,16.1,21,26.4,24.3,26.4l0,0c0.1,0,0.2,0,0.2,0h0.1c1.7-1.2,8.6-22,0.4-40.1 C827.8,547.7,812.9,541,808.1,541z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M874,588.3c-12.8,17.7-32.1,19.7-33.9,17.4c-1.3-2,0.7-23.8,12-40.7 c11.4-17,29.1-24.3,31.5-22.1C887.1,545.8,886.9,570.5,874,588.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167365370860518394650000014578837271122132658_",
    gradientUnits: "userSpaceOnUse",
    x1: 838.9918,
    y1: 312.4999,
    x2: 886.3947,
    y2: 312.4999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167365370860518394650000014578837271122132658_)"
    },
    d: "M843.3,607.3c-2,0-3.3-0.4-3.8-1.1 c-1.6-2.4,0.8-24.9,12-41.7c10.1-15,25.4-22.8,30.8-22.8c0.9,0,1.6,0.2,2,0.6c4.1,3.4,3.1,29-9.6,46.5 C864.1,603.5,849.5,607.3,843.3,607.3z M882.2,543.4c-5.1,0-19.6,7.6-29.4,22.1c-10.9,16.3-13.1,37.8-12,39.8 c0.1,0.1,0.7,0.4,2.5,0.4c6.9,0,20.6-4.7,30-17.8c13.1-18,12.6-42,9.8-44.3C883.1,543.5,882.9,543.4,882.2,543.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M812.7,533.4c9.6,15.9,26.7,24.2,29.2,22.6c2-1,5.9-23.9-5-40.9c-10.8-16.8-29.5-20.1-31.6-18.2 C802.3,499.7,803.2,517.5,812.7,533.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049926918569544531830000005159082698094005435_",
    gradientUnits: "userSpaceOnUse",
    x1: 802.9255,
    y1: 264.2999,
    x2: 845.0596,
    y2: 264.2999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049926918569544531830000005159082698094005435_)"
    },
    d: "M841,557L841,557 c-5.1,0-20.4-9-29-23.2c-9.9-16.3-10.6-34.4-7.3-37.5c0.5-0.5,1.4-0.7,2.8-0.7c5.8,0,20.9,4.7,30.1,19.1 c9.7,15.1,7.7,33.8,6.2,39.1c-0.6,2.1-1.1,2.7-1.5,2.9C842,556.9,841.5,557,841,557z M807.5,497.2c-1.1,0-1.6,0.2-1.7,0.3 c-2.6,2.5-1.9,19.8,7.6,35.4c8.4,13.9,23.3,22.4,27.6,22.4l0,0c0.3,0,0.4-0.1,0.4-0.1h0.1c1.5-1.4,5.3-23-5.3-39.7 C827.3,501.7,813,497.2,807.5,497.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M878.3,533.9c-10.1,19.5-28.9,24.4-31,22.5c-1.6-1.7-2.7-23.7,6.1-42.1 c8.9-18.5,25.3-28.5,28.1-26.7C885.2,489.8,888.5,514.4,878.3,533.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017497056646956004630000008192065136338630276_",
    gradientUnits: "userSpaceOnUse",
    x1: 845.4448,
    y1: 260.05,
    x2: 885.9366,
    y2: 260.05,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017497056646956004630000008192065136338630276_)"
    },
    d: "M849,557.6c-1,0-1.8-0.2-2.2-0.6 c-2-2.2-2.8-24.7,5.9-43.1c8-16.7,22.8-27.4,27.9-27.4c0.5,0,1,0.1,1.3,0.3c4.5,2.7,7.2,28.3-2.9,47.5 C870.5,550.8,855.2,557.6,849,557.6z M847.9,555.8c0,0,0.3,0.1,1,0.1c4.5,0,19.7-5.3,28.6-22.4c10.3-19.8,6.4-43.5,3.4-45.3 c0,0-0.2-0.1-0.5-0.1c-4.2,0-18.5,10-26.4,26.4C845.2,533.4,846.8,554.4,847.9,555.8L847.9,555.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M809.9,489.1c11.8,14.2,29.8,19.8,32.1,17.8c1.8-1.3,2.4-24.6-10.8-39.6 c-13.1-15-32.1-15.4-33.9-13.1C794.8,457.4,798.2,474.9,809.9,489.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176736788672006878130000002728608483232283024_",
    gradientUnits: "userSpaceOnUse",
    x1: 795.7034,
    y1: 218.2,
    x2: 843.765,
    y2: 218.2,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176736788672006878130000002728608483232283024_)"
    },
    d: "M840.3,508.1L840.3,508.1 c-5.6,0-20.9-6.2-31.1-18.5c-12.1-14.6-15.5-32.4-12.6-36c0.9-1.1,3.7-1.3,5.3-1.3c8,0,20.6,3.8,29.9,14.4 c11.6,13.3,12.4,32.1,11.8,37.6c-0.3,2.3-0.7,3-1.1,3.3C842,508,841.3,508.1,840.3,508.1z M801.9,454c-2.6,0-3.8,0.5-4,0.7 c-2.2,2.9,1,19.9,12.6,33.9c10.6,12.8,25.4,17.9,29.8,17.9l0,0c0.9,0,1.1-0.2,1.1-0.2l0.1-0.1c1.3-1.6,1.8-23.9-10.9-38.4 C821.7,457.6,809.6,454,801.9,454z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M874.9,479.5c-7.2,20.9-25.2,28.6-27.5,27c-1.8-1.5-6-23,0-42.6c6.1-19.7,20.9-32.1,23.9-30.8 C875.4,434.8,882.2,458.5,874.9,479.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044178129342680083600000006064583076036466316_",
    gradientUnits: "userSpaceOnUse",
    x1: 843.4489,
    y1: 207.7999,
    x2: 878.8581,
    y2: 207.7999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044178129342680083600000006064583076036466316_)"
    },
    d: "M848.3,507.5c-0.6,0-1-0.1-1.4-0.4 c-2.3-1.8-6.3-24-0.3-43.5c6-19.3,19.9-31.5,24.2-31.5c0.3,0,0.6,0.1,0.9,0.2c4.9,2,11.2,26.9,4,47.4 C869,499,853.2,507.5,848.3,507.5z M847.9,505.8c0,0,0.2,0,0.4,0c4,0,19.3-8,25.8-26.6c7.4-21.2,0.2-44-3.1-45.3 c0,0-0.1,0-0.2,0c-3.4,0-16.8,11.9-22.6,30.3C842.3,483.3,846.3,504.1,847.9,505.8L847.9,505.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M800.8,445.7c13.7,12.2,32.3,15,34.3,12.7c1.6-1.6-1.2-24.7-16.4-37.6 c-15.1-12.8-34-10.2-35.5-7.8C781.1,416.7,787.1,433.5,800.8,445.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006673473938882492220000000484039040276527510_",
    gradientUnits: "userSpaceOnUse",
    x1: 781.9521,
    y1: 173.1499,
    x2: 836.313,
    y2: 173.1499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006673473938882492220000000484039040276527510_)"
    },
    d: "M831.8,460L831.8,460 c-6.3,0-20.5-3.7-31.6-13.6c-14.1-12.6-20-29.6-17.8-33.7c1-1.7,5.6-2.4,9.7-2.4c4.6,0,16.4,1,27.1,10 c11.9,10.1,16.8,27,17.1,35.3c0.1,2.7-0.4,3.3-0.6,3.5C835.1,459.6,833.8,460,831.8,460z M792.1,411.9c-5.2,0-8,1.1-8.3,1.6 c-1.8,3.2,4,19.5,17.5,31.6c10.8,9.6,24.4,13.2,30.5,13.2l0,0c1.8,0,2.5-0.3,2.6-0.5l0.1-0.1c1-1.8-1.7-23.9-16.4-36.3 C807.9,412.8,796.5,411.9,792.1,411.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M863.6,426.2c-4.1,21.8-20.7,32.2-23.3,31c-2-1.2-9.2-21.8-6.2-42.2 c3.2-20.5,15.9-35.1,19.1-34.2C857.5,381.8,867.8,404.3,863.6,426.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057832982737186395120000007627179904288707483_",
    gradientUnits: "userSpaceOnUse",
    x1: 832.6382,
    y1: 156.9999,
    x2: 865.4633,
    y2: 156.9999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057832982737186395120000007627179904288707483_)"
    },
    d: "M840.9,458.1c-0.3,0-0.6-0.1-0.9-0.2 c-2.5-1.4-9.7-22.8-6.6-43.1c3.1-20.2,15.4-34.9,19.6-34.9c0.2,0,0.4,0,0.5,0.1c5.1,1.2,15.1,24.9,11,46.3 C860.5,447.2,845.4,458.1,840.9,458.1z M840.7,456.4L840.7,456.4c3.2,0,18.2-10.1,22-30.4c4.3-22.1-6.3-43.6-9.7-44.4h-0.1 c-3.1,0-14.9,13.9-18,33.5C832,434.9,838.8,454.8,840.7,456.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M785.3,404.2c15.4,10,34.3,9.8,35.9,7.2c1.4-1.8-4.8-24.3-21.9-34.7c-17-10.3-35.4-4.9-36.5-2.2 C761.3,378.5,769.9,394.2,785.3,404.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010280665868920204480000018300232469971095977_",
    gradientUnits: "userSpaceOnUse",
    x1: 761.7301,
    y1: 129.8499,
    x2: 822.1414,
    y2: 129.8499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010280665868920204480000018300232469971095977_)"
    },
    d: "M814.2,413.8L814.2,413.8 c-7.6,0-19.3-2.3-29.4-8.9c-15.9-10.3-24.4-26.3-22.9-30.6c0.8-2.1,7.4-4.4,15.5-4.4c5.5,0,13.8,1.1,22.2,6.2 c13.3,8.1,20.7,24,22.3,32.2c0.5,2.7,0.1,3.4-0.1,3.7C820.8,413.5,816.6,413.8,814.2,413.8z M777.4,371.5 c-8.3,0-13.6,2.5-13.9,3.3c-1.2,3.4,7,18.7,22.2,28.6c9.8,6.3,21.1,8.6,28.5,8.6l0,0c4.2,0,6-0.7,6.2-1.1v-0.1 c0.8-1.9-5.2-23.4-21.7-33.4C790.7,372.6,782.7,371.5,777.4,371.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M844.6,375.1c-0.8,22.2-15.7,35.1-18.4,34.3c-2.2-0.9-12.4-20.2-12.5-40.8 c0-20.8,10.3-37.2,13.6-36.8C831.7,332.1,845.4,352.8,844.6,375.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098921357417983800200000012202718912766489475_",
    gradientUnits: "userSpaceOnUse",
    x1: 812.8504,
    y1: 108.5437,
    x2: 845.449,
    y2: 108.5437,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098921357417983800200000012202718912766489475_)"
    },
    d: "M826.5,410.2c-0.2,0-0.4,0-0.5-0.1 c-2.7-1.1-13-20.6-13.1-41.6c0-16.9,6.7-31.2,11.5-36c1.2-1.2,2.2-1.7,3.1-1.6c5.3,0.4,18.9,22.3,18,44.2 C844.6,397.1,830.1,410.2,826.5,410.2z M826.5,408.6L826.5,408.6c2.5,0,16.5-12.1,17.3-33.5c0.9-22.6-13-42.2-16.5-42.5 c-0.1,0-0.6,0-1.7,1.1c-4.4,4.4-11,18.6-11,34.8C814.6,388.6,824.3,407.2,826.5,408.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M763.5,365.4c16.9,7.5,35.6,4.5,36.7,1.6c1.1-2-8.6-23.3-27.3-30.9c-18.6-7.6-36.1,0.6-36.7,3.5 C735.4,343.7,746.6,357.9,763.5,365.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054976148197820840420000014983337397236781967_",
    gradientUnits: "userSpaceOnUse",
    x1: 735.2595,
    y1: 89.55,
    x2: 801.129,
    y2: 89.55,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054976148197820840420000014983337397236781967_)"
    },
    d: "M786.3,371L786.3,371 c-8,0-16.3-1.7-23.2-4.8c-17.5-7.8-28.6-22.2-27.8-26.8c0.6-2.6,9.8-7.3,21.5-7.3c5.7,0,11.2,1.1,16.4,3.2 c14.6,5.9,24.5,20.6,27.3,28.5c0.9,2.6,0.6,3.3,0.5,3.6C799.9,369.8,792.8,371,786.3,371z M756.8,333.8 c-11.8,0-19.6,4.7-19.9,5.9c-0.7,3.5,10.1,17.4,26.8,24.9c6.7,3,14.7,4.6,22.5,4.6l0,0c8.4,0,12.8-1.8,13.1-2.6v-0.1 c0.5-2-8.9-22.4-26.9-29.8C767.5,334.9,762.2,333.8,756.8,333.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M817.8,327.5c2.7,22.1-10.1,37.2-12.8,36.8c-2.3-0.5-15.4-18.1-18.9-38.5 c-3.4-20.6,4.1-38.4,7.4-38.5C797.9,286.9,815.1,305.2,817.8,327.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065052434515235863250000007716016435573194119_",
    gradientUnits: "userSpaceOnUse",
    x1: 784.2144,
    y1: 63.7499,
    x2: 818.9471,
    y2: 63.7499,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065052434515235863250000007716016435573194119_)"
    },
    d: "M805,365.1c-0.1,0-0.2,0-0.2,0 c-2.9-0.6-16.1-18.4-19.7-39.2c-3-18.1,2.3-33.6,5.8-37.9c0.8-1,1.6-1.5,2.4-1.6h0.1c5.6,0,22.5,19.5,25.1,41 c1.9,15.7-3.8,28.5-9.3,34.7C808.3,363.2,806.5,365.1,805,365.1z M805,363.4v0.8V363.4z M793.5,288.1L793.5,288.1 c-0.2,0-0.7,0.2-1.3,1c-3.3,4.1-8.4,19-5.4,36.6c3.4,19.9,16,36.8,18.3,37.8c0.3,0,1.3-0.5,3-2.4c5.3-6,10.8-18.3,8.9-33.4 C814.2,305.3,797.3,288.1,793.5,288.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M735.3,330.5c18.2,4.8,36.2-1.1,37-4.1c0.8-2.2-12.4-21.8-32.6-26.4c-20-4.7-36.2,6.2-36.3,9.1 C703.3,313.2,717.2,325.6,735.3,330.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089564505729371557120000007370044843789723816_",
    gradientUnits: "userSpaceOnUse",
    x1: 702.5,
    y1: 53.4999,
    x2: 773.1409,
    y2: 53.4999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089564505729371557120000007370044843789723816_)"
    },
    d: "M749.8,333.1L749.8,333.1 c-5.1,0-10-0.6-14.7-1.9c-17.4-4.7-32.6-17.1-32.6-22.2c0.1-3.2,12-11.1,27.2-11.1c3.4,0,6.8,0.4,10.1,1.2 c17.8,4.1,29.5,19.2,32.3,24.1c1.1,2.1,1.1,2.9,1,3.3C772.3,329.6,761.7,333.1,749.8,333.1z M729.7,299.7 c-15,0-25.4,7.6-25.6,9.4c0,3.6,13.2,15.7,31.4,20.5c4.5,1.2,9.3,1.8,14.2,1.8c13,0,21.4-4,21.7-5.3V326 c0.1-2.1-12.2-20.8-32-25.3C736.3,300,733,299.7,729.7,299.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M707.7,282.6c17.2,12.1,37.5,15.2,39.6,13.2c1.6-1.4-2.8-23.5-22.1-37.2 c-19.3-13.7-42.7-12-43.9-9.4C679.6,252.9,690.7,270.4,707.7,282.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173864235911576040020000007853139262575884711_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.3723,
    y1: 9.9,
    x2: 748.5426,
    y2: 9.9,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173864235911576040020000007853139262575884711_)"
    },
    d: "M744.6,297.2L744.6,297.2 c-7.3,0-23.7-4.3-37.3-13.9c-17.1-12.3-28.7-30.1-26.6-34.4c0.9-2.1,7.7-2.3,9.7-2.3c4.6,0,20.6,0.8,35.4,11.4 c16.5,11.7,22.5,29.3,22.8,36c0.1,1.3-0.1,2.1-0.6,2.5C747.6,296.8,746.9,297.2,744.6,297.2z M690.3,248.3 c-5.1,0-7.9,0.9-8.2,1.3c-1.4,2.9,8.8,20,26.1,32.3c13.3,9.4,29.3,13.6,36.4,13.6l0,0c1.5,0,2-0.2,2.2-0.3 c0.9-2.3-3.8-23-22-35.9C710.3,249.1,694.7,248.3,690.3,248.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M783.1,284.4c6.5,21.5-3.8,38.4-6.6,38.4c-2.3-0.2-18.4-15.5-25.5-35.2 c-7.1-19.8-2.8-38.7,0.6-39.3C756.1,247.3,776.7,262.8,783.1,284.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098899740250733708760000014334311068954637727_",
    gradientUnits: "userSpaceOnUse",
    x1: 746.349,
    y1: 23.5999,
    x2: 786.1037,
    y2: 23.5999,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098899740250733708760000014334311068954637727_)"
    },
    d: "M776.5,323.7L776.5,323.7 c-2.9-0.2-19-15.7-26.3-35.7c-6.2-17.5-3.7-33.7-0.9-38.5c0.7-1.1,1.4-1.8,2.2-1.9c0.2,0,0.4-0.1,0.6-0.1 c6.1,0,25.6,15.9,31.9,36.7c5.3,17.5-0.4,31.8-4.2,36.9C778.5,322.8,777.4,323.7,776.5,323.7L776.5,323.7z M752.1,249.2 c-0.1,0-0.2,0-0.3,0s-0.5,0.1-1.1,1.1c-2.6,4.6-5,20.1,1,37.1c7,19.2,22.3,34,24.8,34.6c0.3-0.1,1.1-0.6,2.4-2.6 c3.5-5.4,8.3-18.8,3.4-34.8C776.1,263.9,756.8,249.2,752.1,249.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M694,802.8c0.4-0.2,1.2,0.5,1.9,1.6s0.9,2.2,0.5,2.4c-37.7,22.1-82.5,37.3-134.3,43 c-0.2-1.5-0.3-3-0.5-4.6C612.7,839.5,656.8,824.6,694,802.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061453342831178728150000015761873081983418271_",
    gradientUnits: "userSpaceOnUse",
    x1: 560.7,
    y1: 564.3,
    x2: 697.4318,
    y2: 564.3,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061453342831178728150000015761873081983418271_)"
    },
    d: "M561.4,850.7l-0.7-6.2l0.8-0.1 c48.9-5.4,93.4-19.6,132-42.3c0.2-0.1,0.4-0.2,0.6-0.2c1.1,0,2.2,1.5,2.5,2c0.2,0.4,1,1.8,0.8,2.8c-0.1,0.4-0.4,0.7-0.6,0.8 c-39.4,23.1-84.7,37.6-134.6,43.1L561.4,850.7z M562.5,845.9l0.3,2.9c49.2-5.5,93.9-19.9,132.9-42.6c0-0.2-0.2-0.7-0.6-1.4 c-0.4-0.6-0.8-1-1-1.2C655.6,826.2,611.3,840.4,562.5,845.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#020203"
    },
    d: "M439.3,697c0-138.5,156.3-198.6,156.3-278.3c0-22.7-12.9-43.5-41.1-43.5 c-25.7,0-41.7,18.4-42.9,51.5H443c3.7-77.2,44.1-119.5,110.9-119.5c76.6,0,113.4,54.6,113.4,108.5 c0,112.8-152.6,182.1-152.6,261.1h155.1v66.8H439.3V697z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122691593597863235070000011560914857939459001_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.5,
    y1: 263.3,
    x2: 670.7,
    y2: 263.3,
    gradientTransform: "matrix(1 0 0 1 0 262.0001)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#464545"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04131513,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1053,
    style: {
      stopColor: "#5C5B5B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1839,
    style: {
      stopColor: "#797777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2733,
    style: {
      stopColor: "#A5A5A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2788,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    style: {
      stopColor: "#EFEEEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7576,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#464545"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000122691593597863235070000011560914857939459001_)"
    },
    d: "M670.7,744.4H438.5V697 c0-79.1,50.1-132.1,94.4-178.8c33.2-35.1,61.9-65.4,61.9-99.5c0-19.7-10.5-42.7-40.2-42.7c-25.5,0-40.9,18.5-42.1,50.7v0.8 h-70.3v-0.9c1.8-38.5,12.6-68.5,32-89.3c19.3-20.6,46.1-31.1,79.8-31.1c78.5,0,114.2,56.7,114.2,109.3 c0,61.7-46,111.1-86.7,154.7c-33.7,36.1-65.5,70.2-66,105.6h155.1L670.7,744.4L670.7,744.4z M440.2,742.7H669v-65.1H513.9v-0.8 c0-36.4,32.3-71,66.4-107.6c40.4-43.3,86.2-92.5,86.2-153.5c0-51.9-35.2-107.7-112.6-107.7c-67.1,0-106.2,41.8-110.1,117.9h67 c1.5-32.7,17.4-51.5,43.7-51.5c30.9,0,41.9,23.9,41.9,44.4c0,34.7-28.9,65.2-62.4,100.6c-44,46.5-93.9,99.2-93.9,177.7 L440.2,742.7L440.2,742.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal2Ok);
export default __webpack_public_path__ + "static/media/medal2-ok.3ce246dc9e60743f245433161cea7169.svg";
export { ForwardRef as ReactComponent };